export const sharedConfig = { featherName: 'Feather Insurance' };
